import { MaskingRule } from './rudderStack.types';

export const maskingRules: MaskingRule[] = [
  { pattern: /^\/login\/[^/]+/, replacement: '/login/*' },
  { pattern: /^\/s\/[^/]+/, replacement: '/s/*' },
];
